import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hygiene-check-evaluation-compliance',
  templateUrl: './hygiene-check-evaluation-compliance.component.html',
  styleUrls: ['./hygiene-check-evaluation-compliance.component.css']
})
export class HygieneCheckEvaluationComplianceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
